import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/fare/superadmin`,
});

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

// 📖 Get fare config for a zone (pass nothing for the global default config)
export async function getFareConfig(zoneId) {
  try {
    const res = await API.get("/get", {
      params: zoneId ? { zoneId } : {},
      headers: authHeaders(),
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// 📖 List every zone's fare config, for the zone picker / overview
export async function listFareConfigs() {
  try {
    const res = await API.get("/list", { headers: authHeaders() });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// 💾 Save fare config. Include `zoneId` in payload to target a specific zone,
//    omit it to update the global default config.
export async function saveFareConfig(payload) {
  try {
    const res = await API.post("/save", payload, {
      headers: authHeaders(),
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// 🗑️ Delete a zone's fare config override (global default cannot be deleted)
export async function deleteFareConfig(zoneId) {
  try {
    const res = await API.delete("/delete", {
      params: { zoneId },
      headers: authHeaders(),
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}
